  import React, { useEffect, useRef, useState } from "react";
  import { Link, useLocation, useNavigate } from "react-router-dom";
  import Cookies from "js-cookie";
  import { useContext } from 'react';
  import { NotificationContext } from '../Contexts/NotificationContext';
  import BaseUrl from "../Components/BaseUrl";
  import axios from "axios";
  

  const Navbar = ({ user }) => {
    const { messageCount, notificationCount } = useContext(NotificationContext);
    const modalRef = useRef(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location =useLocation();
    const token=Cookies.get("token");
    const user_id = Cookies.get("user_id")
    const navigate = useNavigate();
 

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
          const profileTrigger = document.querySelector('.profile-trigger');
          if (!profileTrigger.contains(event.target)) {
            setIsModalOpen(false);
          }
        }
      };
      if (isModalOpen) {
        document.addEventListener('mousedown', handleClickOutside);
      }
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [isModalOpen]);

    const isActive = (path) => {
      if (
        (token && path === "/user/home" && location.pathname === "/user/home") ||
        (!token && path === "/" && location.pathname === "/")
      ) {
        return "text-black";
      }
      if (path === "/blog" && location.pathname.startsWith("/blog")) {
        return "text-black";
      }
      if (Array.isArray(path)) {
        return path.some(p => location.pathname.startsWith(p)) ? "text-black" : "text-gray-500";
      }

      return location.pathname === path ? "text-black" : "text-gray-500";
    };

    const handlelogout = async () => {
      const token = Cookies.get('token');
      Cookies.remove("token");
      Cookies.remove("userId");
      navigate("/");
      try {
        const response = await axios.post(
          BaseUrl + 'logout',
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.status === 200) {
          Cookies.remove("token");
          Cookies.remove("userId");
          navigate("/");  
        }
      } catch (error) {
        console.error('Logout failed:', error.response?.data || error.message);
      }
    };

    const getColorFromName = (name) => {
      if (!name) return { backgroundColor: "hsl(0, 0%, 50%)" };
    
      let hash = 0;
      for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
      }
    
      const hue = Math.abs(hash) % 360;
      const saturation = 70 + (Math.abs(hash) % 30); // 70–99%
      const lightness = 50 + (Math.abs(hash) % 10);
    
      return {
        backgroundColor: `hsl(${hue}, ${saturation}%, ${lightness}%)`,
      };
    };
;

    return (
      <div className="fixed top-0 left-0 right-0 bg-white border-b border-gray-200 z-50 ">
        <div className=" container mx-auto ">
          <div className="flex items-center justify-between h-8 bg-white my-4 px-4 sm:px-6 lg:px-8">
            <div className="flex items-center space-x-4 sm:space-x-6">
              <Link to={token ? "/user/home" : "/"}>
                <img
                  src="/Images/logo/Logo-2 1.png"
                  alt="LinkedIn Logo"
                  className="w-30 h-10"
                />
              </Link>
              {location.pathname !== "/user/forgot-password" &&
                location.pathname !== "/user/reset-password" &&
                location.pathname !== "/user/login" &&
                location.pathname !== "/user/register" &&
                location.pathname !== "/user/onboarding/step1" &&
                location.pathname !== "/user/onboarding/step2" &&
                location.pathname !== "/user/onboarding/step3" &&
                location.pathname !== "/user/onboarding/student" &&
                location.pathname !== "/user/onboarding/step4" &&
                location.pathname !== "/user/onboarding/step5" &&
                location.pathname !== "/user/onboarding/step6" &&
                location.pathname !== "/user/onboarding/step7" &&
                location.pathname !== "/user/onboarding/step8" &&
                location.pathname !== "/user/onboarding/step9" && (
                  <div className="relative ml-2">
                    <i className="fas fa-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500"></i>
                    <input
                      type="text"
                      placeholder="Arama Yap"
                      className="pl-10 pr-4 py-2 rounded-md bg-gray-100 focus:outline-none w-48 md:w-64"
                    />
                  </div>
                )}
            </div>
            {!token && (
              <div className="hidden xl:flex items-center space-x-6 sm:space-x-6 md:space-x-8">
                {location.pathname !== "/user/forgot-password" &&
                  location.pathname !== "/user/reset-password" &&
                  location.pathname !== "/user/login" &&
                  location.pathname !== "/user/register" &&
                  location.pathname !== "/user/onboarding/step1" &&
                  location.pathname !== "/user/onboarding/step2" &&
                  location.pathname !== "/user/onboarding/step3" &&
                  location.pathname !== "/user/onboarding/student" &&
                  location.pathname !== "/user/onboarding/step4" &&
                  location.pathname !== "/user/onboarding/step5" &&
                  location.pathname !== "/user/onboarding/step6" &&
                  location.pathname !== "/user/onboarding/step7" &&
                  location.pathname !== "/user/onboarding/step8" &&
                  location.pathname !== "/user/onboarding/step9" && (
                    <Link to="/" className="text-sm mr-6">
                      <div
                        className={`flex flex-col text-black items-center  hover:text-black ${isActive(
                          "/"
                        )}`}
                      >
                        <i className="fas fa-home text-xl"></i>
                        Article
                      </div>
                    </Link>
                  )}

                {location.pathname !== "/user/forgot-password" &&
                  location.pathname !== "/user/reset-password" &&
                  location.pathname !== "/user/login" &&
                  location.pathname !== "/user/register" &&
                  location.pathname !== "/user/onboarding/step1" &&
                  location.pathname !== "/user/onboarding/step2" &&
                  location.pathname !== "/user/onboarding/step3" &&
                  location.pathname !== "/user/onboarding/student" &&
                  location.pathname !== "/user/onboarding/step4" &&
                  location.pathname !== "/user/onboarding/step5" &&
                  location.pathname !== "/user/onboarding/step6" &&
                  location.pathname !== "/user/onboarding/step7" &&
                  location.pathname !== "/user/onboarding/step8" &&
                  location.pathname !== "/user/onboarding/step9" && (
                    <Link to="/user/register" className="text-md">
                      <div
                        className={`flex flex-col text-gray-600 items-center border border-white font-semibold rounded-full px-6 py-3 hover:text-black  hover:bg-gray-100
                : ${isActive("/user/register")}`}
                      >
                        Join now
                      </div>
                    </Link>
                  )}

                {location.pathname !== "/user/forgot-password" &&
                  location.pathname !== "/user/reset-password" &&
                  location.pathname !== "/user/login" &&
                  location.pathname !== "/user/register" &&
                  location.pathname !== "/user/onboarding/step1" &&
                  location.pathname !== "/user/onboarding/step2" &&
                  location.pathname !== "/user/onboarding/step3" &&
                  location.pathname !== "/user/onboarding/student" &&
                  location.pathname !== "/user/onboarding/step4" &&
                  location.pathname !== "/user/onboarding/step5" &&
                  location.pathname !== "/user/onboarding/step6" &&
                  location.pathname !== "/user/onboarding/step7" &&
                  location.pathname !== "/user/onboarding/step8" &&
                  location.pathname !== "/user/onboarding/step9" && (
                    <Link to="/user/login" className="text-sm ">
                      <div
                        className={`flex flex-col text-blue-600 items-center border border-blue-600 rounded-full px-6 py-3 hover:text-blue-800 hover:border-blue-800 hover:bg-blue-100
                : ${isActive("/user/login")}`}
                      >
                        <span className="text-sm text-blue-600">Sign In</span>
                      </div>
                    </Link>
                  )}
              </div>
            )}
            {token && (
              <>
                <div className="hidden xl:flex items-center space-x-6 sm:space-x-6 md:space-x-8">
                  <Link to="/user/home" className="text-sm mr-6">
                    <div
                      className={`flex flex-col text-black items-center  hover:text-black ${isActive(
                        "/user/home"
                      )}`}
                    >
                      <i className="fas fa-home text-xl"></i>
                      Home
                    </div>
                  </Link>
                  <Link to="/user/networks" className="text-sm !ml-0">
                    <div
                      className={`flex flex-col text-black items-center   hover:text-black ${isActive(
                        [
                          "/user/networks",
                          "/user/networks/connections",
                          "/user/networks/following-followers",
                          "/user/networks/manageinvitation",
                        ]
                      )}`}
                    >
                      <i className="fas fa-users text-xl"></i>
                      My Networks
                    </div>
                  </Link>
                  <Link to="/user/jobs" className="text-sm">
                    <div
                      className={`flex flex-col text-black items-center  hover:text-black ${isActive(
                        "/user/jobs"
                      )}`}
                    >
                      <i className="fas fa-briefcase text-xl"></i>
                      Jobs
                    </div>
                  </Link>
                  <Link to="/user/messaging" className="text-sm">
                    <div
                      className={`relative flex flex-col text-black items-center hover:text-black ${isActive(
                        "/user/messaging"
                      )}`}
                    >
                      <div className="relative">
                        <i className="fas fa-comment-dots text-xl"></i>

                        {messageCount > 0 && (
                          <span
                            style={{
                              position: "absolute",
                              top: "-5px",
                              right: "-6px",
                              background: "red",
                              color: "white",
                              borderRadius: "999px",
                              padding: "0 5px",
                              minWidth: "16px",
                              height: "16px",
                              fontSize: "9px",
                              fontWeight: "600",
                              lineHeight: "16px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxSizing: "border-box",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {messageCount > 99 ? "99+" : messageCount}
                          </span>
                        )}
                      </div>

                      <span className="text-sm">Messaging</span>
                    </div>
                  </Link>
                  <Link to="/user/notifications" className="text-sm">
                    <div
                      className={`relative flex flex-col text-black items-center  hover:text-black ${isActive(
                        "/user/notifications"
                      )}`}
                    >
                      <div className="relative">
                        <i className="fas fa-bell text-xl"></i>
                        {notificationCount > 0 && (
                          <span
                            style={{
                              position: "absolute",
                              top: "-5px",
                              right: "-6px",
                              background: "red",
                              color: "white",
                              borderRadius: "999px",
                              padding: "0 5px",
                              minWidth: "16px",
                              height: "16px",
                              fontSize: "9px",
                              fontWeight: "600",
                              lineHeight: "16px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxSizing: "border-box",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {notificationCount > 99 ? "99+" : notificationCount}
                          </span>
                        )}
                      </div>
                      <span className="text-sm">Notification</span>
                    </div>
                  </Link>
                  <Link to="#" className="text-sm">
                    <div className="relative">
                      <div
                        className={`profile-trigger flex flex-col items-center cursor-pointer hover:text-black ${isActive(
                          "/user/userprofile"
                        )}`}
                        onClick={() => setIsModalOpen(!isModalOpen)}
                      >
                        {user.profile ? (
                          <img
                            src={user.profile}
                            alt={user.name}
                            className="w-6 h-6 rounded-full"
                          />
                        ) : (
                          <div
                            className="w-8 h-8 rounded-full flex items-center justify-center text-white font-bold text-sm"
                            style={getColorFromName(user.name || "U")}
                          >
                            {(user.name || "U").charAt(0).toUpperCase()}
                          </div>
                        )}
                        <span className="text-sm">User</span>
                      </div>

                      {isModalOpen && (
                        <div
                          ref={modalRef}
                          className="absolute fixed right-0 mt-3 w-64 bg-white rounded-sm shadow-lg py-1 z-10 border border-gray-200"
                        >
                          <div className="px-4 py-2 border-b border-gray-200">
                            <div className="flex items-center space-x-3">
                              {user.profile ? (
                                <img
                                  src={user.profile}
                                  alt={user.name}
                                  className="w-10 h-10 rounded-full"
                                />
                              ) : (
                                <div
                                  className="w-8 h-8 rounded-full flex items-center justify-center text-white font-bold text-sm"
                                  style={getColorFromName(user.name || "?")}
                                >
                                  {(user.name || "?").charAt(0).toUpperCase()}
                                </div>
                              )}

                              <div>
                                <p className="font-medium">{user.name}</p>
                                <p className="text-sm text-gray-500">
                                  {user.headline}
                                </p>
                              </div>
                            </div>
                          </div>

                          <Link
                            to="/user/userprofile"
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                            onClick={() => setIsModalOpen(false)}
                          >
                            View Profile
                          </Link>
                          <a
                            href="/account/settings"
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                            onClick={() => setIsModalOpen(false)}
                          >
                            Settings
                          </a>
                          <div className="border-t border-gray-200"></div>
                          <Link
                            to="/#"
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                            onClick={handlelogout}
                          >
                            Sign Out
                          </Link>
                        </div>
                      )}
                    </div>
                  </Link>
                  <Link to="/user/business" className="text-sm">
                    <div
                      className={`flex flex-col text-black items-center  hover:text-black ${isActive(
                        "/user/business"
                      )}`}
                    >
                      <i className="fas fa-th text-xl"></i>
                      <span className="text-sm">For Business</span>
                    </div>
                  </Link>
                </div>
                <div className="text-yellow-600 hover:text-yellow-800">
                  <button onClick={handlelogout}>
                    <span className="text-sm">Log Out</span>
                  </button>
                </div>
              </>
            )}

            <div className="xl:hidden flex justify-between items-center">
              <button
                className="text-gray-500 hover:text-black"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                <i
                  className={`fas fa-bars text-xl ${
                    isMenuOpen ? "rotate-90" : ""
                  }`}
                ></i>{" "}
              </button>
            </div>
          </div>

          {isMenuOpen && (
            <div className="xl:hidden flex flex-col gap-2 bg-white py-4 px-4 sm:px-6 lg:px-8 mx-auto">
              <div className="flex flex-col items-center justify-center text-gray-500 hover:text-black">
                <i className="fas fa-home text-xl"></i>
                <Link to="/" className="text-sm">
                  <div
                    className={`flex flex-col items-center text-lg hover:text-black ${isActive(
                      "/"
                    )}`}
                  >
                    Article
                  </div>
                </Link>
              </div>
              <div className="flex flex-col items-center justify-center text-gray-500 hover:text-black">
                <i className="fas fa-users text-xl"></i>
                <Link to="/user/networks" className="text-sm">
                  My Networks
                </Link>
              </div>
              <div className="flex flex-col items-center justify-center text-gray-500 hover:text-black">
                <i className="fas fa-briefcase text-xl"></i>
                <span className="text-sm">Jobs</span>
              </div>
              <div className="flex flex-col items-center justify-center text-gray-500 hover:text-black">
                <i className="fas fa-comment-dots text-xl"></i>
                <span className="text-sm">Messaging</span>
              </div>
              <div className="flex flex-col items-center justify-center text-gray-500 hover:text-black">
                <i className="fas fa-bell text-xl"></i>
                <span className="text-sm">Notification</span>
              </div>
              <div className="flex flex-col items-center justify-center text-gray-500 hover:text-black">
                <img
                  src="https://placehold.co/30x30"
                  alt="User Avatar"
                  className="w-6 h-6 rounded-full"
                />
                <span className="text-sm">User</span>
              </div>
              <div className="flex flex-col items-center justify-center text-gray-500 hover:text-black">
                <i className="fas fa-th text-xl"></i>
                <span className="text-sm">For Business</span>
              </div>
              <div className="text-yellow-600 text-center hover:text-yellow-800">
                <span className="text-sm">Try Premium Now</span>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  export default Navbar;






